import React  from 'react'
import {  useState, useRef, useEffect } from "react";

// import ReactDOM from "react-dom/client";
// import { BrowserRouter as Router,  Route } from "react-router-dom";

import Header from './components/Header';
// import FooterTest from './components/FooterTest';
import Clock from './components/Clock';

import Tasks  from './components/Tasks';
import AddTask  from './components/AddTask';

// import AnimateControls from './components/AnimateControls';
import Switch from "./Switch";

// import useSpring from 'react-spring'
// import Howling from  './components/Howling';


import Player from './Player/Player';
import {songsdata} from './Player/Audio';
// import {AudioFX} from './Player/AudioFX' ;
// import  './sounds/dronefx.mp3';

import music from './components/images/bg-music.png'
import refresh  from '../src/refreshsymbol.jpg'

import './App.css'
import './Animations.css'
import Loader from './components/SpaceWarp';
import Howling from './components/Howling';



// Cache references to space DOM elements.
// var spaceElements = ['react-blue', 'music-icon', 'switch-orange', 'black-jog-dial, 'react-white', ' astronaut-hovering', 'space-warp', 'space-ufo-technician', 'refresh-page', 'audio-player', 'close-btn', 'prevBtn', 'nextBtn', 'playlistBtn', 'volumeBtn', 'progress', 'bar', 'wave', 'loading', 'playlist', 'list', 'volume', 'barEmpty', 'barFull', 'sliderBtn'];
// spaceElements.forEach(function(elm) {
//   window[elm] = document.getElementById(elm);
// });

// INCLUDE THESE TWO, when you are ready: [showAnimationControl, setShowAnimationControl ]
export const App = ()  => {
  const [showAddTask, setShowAddTask] = useState(false)
  const [tasks, setTasks] = useState([
    {
        id: 1,
        text: 'Pray and Act on Love !',
        day: 'Daily',
        reminder: false
    },

    {
      id: 2,
      text: 'Study',
      day: 'Today',
      reminder: false
  },
])

//Add Task
const addTask = (task) => {
  const id = Math.floor(Math.random() * 10000) + 1
  const newTask = { id, ...task }
    setTasks([...tasks, newTask])
  }

  //Delete Task
  const deleteTask = (id) => {
    setTasks(tasks.filter((task) => task.id !== id))
  }
  //Toggle Reminder
  const toggleReminder = (id) => {
    setTasks(
      tasks.map((task) => 
      task.id === id ? {...task, reminder: 
      !task.reminder } : task
         )
      )
  }
// let toggle = e => this.setState({ showPlayer: !this.state.showPlayer });

// Start of: Audio Portion
const [songs, setSongs] = useState(songsdata);
const [isplaying, setisplaying] = useState(!useState);
const [currentSong, setCurrentSong] = useState(songsdata[0]);

// const [songFX, setSongFX] = useState(spacesoundfx );
// const [isplayingFX, setisplayingFX] = useState(!useState);
// const [currentFX, setCurrentFX] = useState(spacesoundfx [0]);

 const audioElem = useRef();
  useEffect(() => {
    if (isplaying) {
      Howling.stop();
      audioElem.current.play();

    }   
    else {
      Howling.stop();
      audioElem.current.pause();
  
    }
  }, [isplaying])

  const onPlaying = () => {
    Howling.stop();
    const duration = audioElem.current.duration;
    const ct = audioElem.current.currentTime;

    setCurrentSong({ ...currentSong, "progress": ct / duration * 100, "length": duration })
// End of: Audio Portion
  }

//Refresh page
const  refreshPage = () => {
  window.location.reload(true);
  // Howling.play();
}

  return (

    <div className="App  entire-page-show ">
      <Header  title="Space-age Task Tracker " style={{ zIndex:1 }}className="task-tracker header-img"  onAdd={() => setShowAddTask(!showAddTask)} showAdd={showAddTask}  />
        

      {showAddTask && <AddTask className="Container" id='Container'  onAdd={addTask} />}

      <img src={refresh} className="Refresh-logo" alt="logo"  onClick={refreshPage}  />
     {/* Monkey Audio Visualizer Player */}
      <a href="https://www.product66.com/websandbox/portfolio/audiohowl/player/audiohowl.htm" target="_blank" rel="noopener noreferrer">
      <img src={music} className="monkeyvisualizer" alt ="Monkey Audio Visualizer" title="Monkey Audio Visualizer" /> 
      </a>

{/* CD Spinning Audio Player */}
<a href="https://www.product66.com/websandbox/portfolio/audioplayer/audioplayer.html" target="_blank" rel="noopener noreferrer">
      <img src={music} className="cdspinningplayer" alt ="CD Spinning Audio Player" title="CD Spinning Audio Player" /> 
      </a>

       

        {/* Toggle Switch State for Audio Player or Animation */}
        <Switch  isOn={false}
        handleToggle={() => refreshPage() }  />

      {tasks.length > 0 ? (
          <Tasks tasks={tasks} onDelete={deleteTask} onToggle={toggleReminder} />
       )  :  ( 
         <h1> There is nothing left to show! </h1> 
        
       )}

<audio src={currentSong.url} ref={audioElem} onTimeUpdate={onPlaying} />
<Player songs={songs} setSongs={setSongs} isplaying={isplaying} setisplaying={setisplaying}
 audioElem={audioElem} currentSong={currentSong} setCurrentSong={setCurrentSong} />
 < Loader />

 <Clock />

</div>

  )
}

export default App;

